import React, { useState } from 'react';
// import { Pie } from 'react-chartjs-2';

const PersonalEmiCalculator: React.FC = () => {
    const [loanAmount, setLoanAmount] = useState<number>(50000);
    const [interestRate, setInterestRate] = useState<number>(10);
    const [loanTenure, setLoanTenure] = useState<number>(12);
    const [processingFee, setProcessingFee] = useState<number>(0);
    const [emi, setEmi] = useState<number>(0);
    const [totalInterest, setTotalInterest] = useState<number>(0);
    const [totalPayment, setTotalPayment] = useState<number>(0);

    const calculateEMI = () => {
        const monthlyRate = interestRate / 12 / 100;
        const numberOfMonths = loanTenure;
        const emi =
            monthlyRate === 0
                ? loanAmount / numberOfMonths
                : (loanAmount * monthlyRate * Math.pow(1 + monthlyRate, numberOfMonths)) /
                  (Math.pow(1 + monthlyRate, numberOfMonths) - 1);
        const totalPayment = emi * numberOfMonths + processingFee;
        const totalInterest = totalPayment - loanAmount - processingFee;

        setEmi(emi);
        setTotalInterest(totalInterest);
        setTotalPayment(totalPayment);
    };

    const pieData = {
        labels: ['Loan Amount', 'Total Interest', 'Processing Fee'],
        datasets: [
            {
                data: [loanAmount, totalInterest, processingFee],
                backgroundColor: ['#FFA500', '#6A5ACD', '#00BFFF'],
            },
        ],
    };

    return (
        <div className="container mt-5">
            <h1>How to Calculate Personal Loan EMI</h1>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label>Loan Amount:</label>
                        <input
                            type="number"
                            className="form-control"
                            value={loanAmount}
                            onChange={(e) => setLoanAmount(Number(e.target.value))}
                        />
                        <input
                            type="range"
                            className="form-range"
                            min="0"
                            max="1000000"
                            step="1000"
                            value={loanAmount}
                            onChange={(e) => setLoanAmount(Number(e.target.value))}
                        />
                    </div>
                    <div className="form-group">
                        <label>Interest Rate:</label>
                        <input
                            type="number"
                            className="form-control"
                            value={interestRate}
                            onChange={(e) => setInterestRate(Number(e.target.value))}
                        />
                        <input
                            type="range"
                            className="form-range"
                            min="0"
                            max="20"
                            step="0.1"
                            value={interestRate}
                            onChange={(e) => setInterestRate(Number(e.target.value))}
                        />
                    </div>
                    <div className="form-group">
                        <label>Loan Tenure (Months):</label>
                        <input
                            type="number"
                            className="form-control"
                            value={loanTenure}
                            onChange={(e) => setLoanTenure(Number(e.target.value))}
                        />
                        <input
                            type="range"
                            className="form-range"
                            min="1"
                            max="360"
                            step="1"
                            value={loanTenure}
                            onChange={(e) => setLoanTenure(Number(e.target.value))}
                        />
                    </div>
                    <div className="form-group">
                        <label>Processing Fee:</label>
                        <input
                            type="number"
                            className="form-control"
                            value={processingFee}
                            onChange={(e) => setProcessingFee(Number(e.target.value))}
                        />
                        <input
                            type="range"
                            className="form-range"
                            min="0"
                            max="10000"
                            step="100"
                            value={processingFee}
                            onChange={(e) => setProcessingFee(Number(e.target.value))}
                        />
                    </div>
                    <button className="btn btn-primary mt-3" onClick={calculateEMI}>
                        Calculate EMI
                    </button>
                </div>
                <div className="col-md-6">
                    <h3>Your Monthly Loan EMI: ₹{emi.toFixed(2)}</h3>
                    {/* <Pie data={pieData} /> */}
                    <div className="mt-4">
                        <p>Loan Amount: ₹{loanAmount}</p>
                        <p>Total Interest: ₹{totalInterest.toFixed(2)}</p>
                        <p>Processing Fee: ₹{processingFee}</p>
                        <p>Total Payment: ₹{totalPayment.toFixed(2)}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonalEmiCalculator;